var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskManagementHeaderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.362 4.50001H15.2501V4.14226C15.2501 3.51128 14.7389 3 14.1079 3H8.89238C8.26143 3 7.75012 3.51128 7.75012 4.14226V4.50001H5.638C4.73329 4.50001 4 5.2333 4 6.13801V19.362C4 20.2667 4.73329 21 5.638 21H17.362C18.2667 21 19 20.2667 19 19.362V6.13801C19 5.2333 18.2667 4.50001 17.362 4.50001ZM9.25013 4.50001H13.75V6.00002H9.25013V4.50001ZM17.362 19.5C17.4383 19.5 17.5 19.4383 17.5 19.362V6.13798C17.5 6.06169 17.4383 5.99999 17.362 5.99999H15.2502V6.35777C15.2502 6.98876 14.7389 7.50004 14.1079 7.50004H14.1078H8.89241H8.89227C8.26129 7.50004 7.75001 6.98872 7.75001 6.35777V6.00002H5.638C5.56171 6.00002 5.50001 6.06172 5.50001 6.13801V19.362C5.50001 19.4383 5.56171 19.5 5.638 19.5H17.362Z",
    fill: "#587E85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0498 10H8.04983C7.63558 10 7.2998 10.3358 7.2998 10.75C7.2998 11.1642 7.63558 11.5 8.04979 11.5H15.0498C15.464 11.5 15.7998 11.1642 15.7998 10.75C15.7998 10.3358 15.464 10 15.0498 10Z",
    fill: "#587E85"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7197 13.7197L11.25 16.1893L10.2803 15.2196C9.98744 14.9268 9.51255 14.9268 9.21967 15.2196C8.92678 15.5125 8.92678 15.9874 9.21967 16.2803L10.7197 17.7803C11.0126 18.0732 11.4875 18.0732 11.7803 17.7803L14.7803 14.7803C15.0732 14.4874 15.0732 14.0126 14.7803 13.7197C14.4874 13.4268 14.0126 13.4268 13.7197 13.7197Z",
    fill: "#587E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskManagementHeaderIcon);
export default __webpack_public_path__ + "static/media/task_management_header_icon.0d19d869da2b74f3c8ab1cb4107248cb.svg";
export { ForwardRef as ReactComponent };